// Unified lead capture for WhatsApp-led funnel.
// Exposes two variants:
//  - saveLead(payload)        -> fire-and-forget (kept for any legacy callers)
//  - saveLeadAwait(payload)   -> awaitable, used by the Save-First-Then-Redirect flow

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Fire-and-forget write. Uses keepalive so the request survives navigation.
 */
export function saveLead(payload) {
  try {
    fetch(`${API}/leads`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch((err) => {
      console.warn('[saveLead] request failed:', err?.message);
    });
  } catch (err) {
    console.warn('[saveLead] sync error:', err?.message);
  }
}

/**
 * Awaitable write. Throws on network/HTTP failure so the caller can abort the
 * WhatsApp redirect and show an error to the user.
 * Returns the created lead document.
 */
export async function saveLeadAwait(payload) {
  console.info('[saveLead] ▶︎ saving lead (type=%s)', payload?.type);
  const resp = await fetch(`${API}/leads`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const text = await resp.text();
  let data;
  try { data = JSON.parse(text); } catch { data = { raw: text }; }

  if (!resp.ok) {
    console.error('[saveLead] ✗ failed', resp.status, data);
    const err = new Error(data?.detail || `HTTP ${resp.status}`);
    err.status = resp.status;
    err.data = data;
    throw err;
  }

  console.info('[saveLead] ✓ saved lead_id=%s', data?.lead_id);
  return data;
}
